import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { USER_LOGGED_IN } from "../Reducer/authSlice";
import API from "../Network/API";
import { MENU_FETCH_SUCCESS } from "../Reducer/menuSlice";
import { CATEGORY_FETCH_SUCCESS } from "../Reducer/categorySlice";
import { HOME_FETCH_COURSE_SUCCESS, HOME_FETCH_START } from "../Reducer/homeSlice";
import { COURSE_FETCH_START, COURSE_FETCH_SUCCESS, COURSE_TOTAL_PAGE } from "../Reducer/courseSlice";
import { APPEARANCE_FETCH_ERROR, APPEARANCE_FETCH_SUCCESS } from "../Reducer/appearanceSlice";
import { TEACHER_FETCH_START, TEACHER_FETCH_SUCCESS, TEACHER_TOTAL_PAGE } from "../Reducer/teacherSlice";
import { COUNTRY_FETCH_SUCCESS } from "../Reducer/countrySlice";
import { LANGUAGE_FETCH_SUCCESS } from "../Reducer/languageSlice";
import { useTranslation } from "react-i18next";
import MobileDrawer from "./MobileDrawer";
import LocaleSwitcher from "./LocaleSwitcher";

export default function Header() {
  const dispatch = useDispatch();
  const navigator = useNavigate();
  const { user, accessToken } = useSelector((state) => state.authReducer);
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = useCallback(() => setMenuOpen(false), []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  // useEffect(() => {
  //   const userInfo = JSON.parse(localStorage.getItem("xller_auth"));
  //   if (userInfo) {
  //     dispatch(USER_LOGGED_IN(userInfo));
  //   }

  // }, [dispatch]);

  // useEffect(() => {

  //   API.get(`/menus`).then((response) => {
  //     dispatch(MENU_FETCH_SUCCESS(response.data.data))
  //   }).catch((error) => {
  //   });

  //   API.get('/appearance').then((response) => {
  //     dispatch(APPEARANCE_FETCH_SUCCESS(response.data.data));
  //   }).catch((error) => {
  //     dispatch(APPEARANCE_FETCH_ERROR());
  //   });

  //   API.get(`/v1/oauth/categories`).then((response) => {
  //     dispatch(CATEGORY_FETCH_SUCCESS(response.data.data.categories))
  //   }).catch((error) => {
  //   });

  //   API.get(`/v1/oauth/countries`).then((response) => {
  //     dispatch(COUNTRY_FETCH_SUCCESS(response.data.data.countries))
  //   }).catch((error) => {
  //   });

  //   API.get(`/v1/oauth/language`).then((response) => {
  //     dispatch(LANGUAGE_FETCH_SUCCESS(response.data.data.languages))
  //   }).catch((error) => {
  //   });


  //   API.get(`/v1/oauth/check_user`).then((response) => {

  //     localStorage.setItem(
  //       'xller_auth',
  //       JSON.stringify({
  //           user: response?.data?.user,
  //           accessToken: localStorage.getItem('xller_token'),
  //       })
  //   )

  //   const userInfo = JSON.parse(localStorage.getItem("xller_auth"));
  //   if (userInfo) {
  //       dispatch(USER_LOGGED_IN(userInfo));
  //   }

  //   }).catch((error) => {
  //     // console.log(error?.response?.status);
  //     if(error?.response?.status==401 && error?.response?.statusText=="Unauthorized"){
  //       // navigator('/login')
  //       // localStorage.clear();
  //     }
  //   });

  //   dispatch(HOME_FETCH_START())
  //   dispatch(COURSE_FETCH_START())
  //   dispatch(TEACHER_FETCH_START())

  //   API.get(`/v1/oauth/all_course`).then((response) => {
  //     dispatch(COURSE_FETCH_SUCCESS(response.data.data))
  //     dispatch(COURSE_TOTAL_PAGE(response.data.data.total_page))
  //     dispatch((HOME_FETCH_COURSE_SUCCESS(response.data.data.courses)))
  //   }).catch((error) => {
  //   });

  //   API.get(`/v1/oauth/all_teachers`).then((response) => {
  //     dispatch(TEACHER_FETCH_SUCCESS(response.data.data))
  //     dispatch(TEACHER_TOTAL_PAGE(response.data.data.total_page))
  //   }).catch((error) => {
  //   });





  // }, []);


  return (
    <>
      <header className={`mainHarder ${scrolled ? "is-sticky" : ""}`}>
        <nav className="navbar navbar-expand-lg  mainHarderNavbar">
          <div className="container">
            <Link className="navbar-brand mainHarderLogo" to="/">
              <img src="/assets/img/logo.svg" alt="xller" />
            </Link>
            <button className="navbar-toggler" type="button" onClick={() => setMenuOpen(true)} aria-label={t('header.toggle_navigation')}>
              <span className="navbar-toggler-icon" />
            </button>
            <div className="collapse navbar-collapse mainHarderMenu" id="navbarSupportedContent">
              <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                <li className="nav-item d-flex align-items-center">
                  <LocaleSwitcher />
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={`/teachers`}>{t(`find_tutor`)}</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={`/all-courses`}>{t('all_course')}</Link>
                </li>
                {user?.role === 'teacher' ?
                  <li className="nav-item">
                    <Link className="nav-link" to={`/dashboard/my-courses`}>{t('header.your_courses')}</Link>
                  </li>
                  :
                  <li className="nav-item">
                    <Link className="nav-link" to={`/teach`}>{t('become_tutors')}</Link>
                  </li>
                }

                {!accessToken ?
                  <li className="nav-item">
                    <Link className="nav-link" to={`/login`}>{t('header.login')}</Link>
                  </li>
                  :
                  <>
                    {accessToken && user?.role == 'teacher' ?
                      <li className="nav-item">
                        <Link className="nav-link" to={`/dashboard/tutor`}>{t('header.dashboard')}</Link>
                      </li>
                      :
                      <li className="nav-item">
                        <Link className="nav-link" to={`/home/student`}>{t('header.dashboard')}</Link>
                      </li>

                    }
                  </>
                }


                

                {!accessToken ?
                  <li className="nav-item">
                    <Link className=" btn btn-outline-mainColor" to={`/signup-student`}>{t('header.sign_up')}</Link>
                  </li>
                  : ''
                }
              </ul>
            </div>
          </div>
        </nav>
      </header>

      <div className={`mobile-menu ${scrolled ? "is-sticky" : ""}`}>
        <nav className="navbar fixed-top bg-white">
          <div className="container">
            <Link className="navbar-brand mainHarderLogo" to="/">
              <img src="/assets/img/logo.svg" alt="xller" />
            </Link>
            <button
              type="button"
              className="mobile-menu-toggle"
              onClick={() => setMenuOpen(true)}
              aria-expanded={menuOpen}
              aria-label={t('header.toggle_navigation')}
            >
              <i className="fa-light fa-bars" />
            </button>
          </div>
        </nav>
      </div>
      <MobileDrawer open={menuOpen} onClose={closeMenu} />


    </>
  )
}